import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { CompatTrackingComponent } from './compat-tracking.component';

@NgModule({
  imports: [TrackingModule],
  declarations: [CompatTrackingComponent],
})
export class CompatTrackingModule {}
